import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=04c8314e"
import script from "./Header.js?vue&type=script&lang=js&external"
export * from "./Header.js?vue&type=script&lang=js&external"
import style0 from "./Header.vue?vue&type=style&index=0&id=04c8314e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports